var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRingAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0699 2.28872L16.3358 3.53965C16.7097 3.90922 16.7336 4.50527 16.3905 4.90361L13.3991 8.37596C17.0115 9.03458 19.75 12.1975 19.75 16C19.75 20.2802 16.2802 23.75 12 23.75C7.71979 23.75 4.25 20.2802 4.25 16C4.25 12.1975 6.98852 9.03458 10.6009 8.37596L7.60953 4.90361C7.26636 4.50527 7.29027 3.90922 7.66425 3.53965L8.93006 2.28872C9.11725 2.10374 9.36981 2 9.63297 2H14.367C14.6302 2 14.8828 2.10374 15.0699 2.28872ZM5.75 16C5.75 19.4518 8.54822 22.25 12 22.25C15.4518 22.25 18.25 19.4518 18.25 16C18.25 12.5482 15.4518 9.75 12 9.75C8.54822 9.75 5.75 12.5482 5.75 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingAlt1);
export default __webpack_public_path__ + "static/media/ring-alt-1.446f05dc6df36400fba31b914707d707.svg";
export { ForwardRef as ReactComponent };